import { useEffect } from 'react';
import { NavLink } from 'react-router-dom';

type MobileMenuProps = {
  isOpen: boolean;
  onClose: () => void;
};

const navItems = [
  { label: 'Dashboard', to: '/dashboard' },
  { label: 'Month Overview', to: '/months' },
  { label: 'Transactions', to: '/transactions' },
  { label: 'Pending Payments', to: '/pending-payments' },
  { label: 'Stake Snapshots', to: '/stake-snapshots' },
  { label: 'Audit Logs', to: '/audit-logs' },
  { label: 'Profile', to: '/profile' },
  { label: 'Change Password', to: '/change-password' },
];

export const MobileMenu = ({ isOpen, onClose }: MobileMenuProps) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <>
      <div className="mobile-menu-overlay" onClick={onClose} />
      <aside className="mobile-menu">
        <div className="mobile-menu-header">
          <div>
            <div className="badge" style={{ background: 'rgba(11, 77, 153, 0.2)', color: '#0b4d99' }}>
              HASH SOFTWARE
            </div>
            <h3 style={{ margin: '12px 0 4px', fontSize: '1.2rem', fontWeight: 600 }}>Revenue Tracker</h3>
            <p style={{ margin: 0, opacity: 0.72, fontSize: '0.85rem', color: '#334155' }}>Finance cockpit for founders</p>
          </div>
          <button className="mobile-menu-close" onClick={onClose} aria-label="Close menu">
            ✕
          </button>
        </div>
        <nav className="mobile-menu-nav">
          {navItems.map((item) => (
            <NavLink
              key={item.label}
              to={item.to}
              className={({ isActive }) => `mobile-menu-link ${isActive ? 'active' : ''}`}
              onClick={onClose}
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
      </aside>
    </>
  );
};

